import React from 'react';
import { Box, Flex, Text, Input, Button, VStack ,Select} from '@chakra-ui/react';
import { useState, useRef, useEffect } from 'react';
import { FaUser, FaRobot } from 'react-icons/fa';
function Friend() {
  const [messages, setMessages] = useState([
    { id: 1, text: "Hello!", sender: "sender" },
    { id: 2, text: "Hi there!", sender: "receiver" },

]);
const [isTyping, setIsTyping] = useState(false);
const [newMessage, setNewMessage] = useState('');
const messagesEndRef = useRef(null);
const [languages, SetLanguages] = useState("")

const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
};

useEffect(() => {
    scrollToBottom();
}, [messages]);

const addMessage = (text, sender) => {
    setMessages(prevMessages => [
        ...prevMessages,
        { id: prevMessages.length + 1, text, sender, time: Date(), userID: prevMessages.length + 1 }
    ]);
    setIsTyping(false);
};
console.log(messages, languages)
const handleSendMessage = async () => {
    if (newMessage.trim() === '') return;

    const userMessage = newMessage.trim();
    addMessage(userMessage, 'sender'); // Add user's message immediately
    setNewMessage(''); // Clear input field
    setIsTyping(true);

    // Simulate receiver's response after a delay (you can replace this with actual fetch)
    simulateReceiverResponse(userMessage);
};

const addReceiverMessage = (text) => {
    addMessage(text, 'receiver'); // Add receiver's response
};

// Function to simulate receiver's response (replace this with actual fetch)
const simulateReceiverResponse = async (userMessage) => {
    const url = 'https://misty-red-lovebird.cyclic.app/friend';
    // const url = 'https://misty-red-lovebird.cyclic.app/mentor';

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ message: newMessage, language: languages }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const result = await response.json();
        //   addMessage(result.message, 'receiver');
        addReceiverMessage(result.message)
    } catch (error) {
        console.error('Error:', error);
    }

};

return (
    <>
        <Flex direction="column" h="100vh">
            <Box flex="1" bg="gray.50" overflowY="scroll" scrollbarWidth="none" style={{ background: "linear-gradient(90deg, rgb(217 128 250) 0%, rgb(234 224 210) 100%)" }}
                backgroundSize="cover"
                backgroundPosition="center"
                backgroundRepeat="no-repeat" css={{ '&::-webkit-scrollbar': { display: 'none' } }}>
                <VStack spacing={4} align="stretch" p={4}>
                    {messages.map((message) => (
                        <Flex key={message.id} justify={message.sender === 'sender' ? 'flex-end' : 'flex-start'}>
                            <Box maxW="80%" px={3} py={1} borderRadius="lg" bg={message.sender === 'sender' ? 'teal.400' : 'gray.200'} color={message.sender === 'sender' ? 'white' : 'black'}>
                                {message.sender === 'sender' ? <FaUser mr={2} /> : <FaRobot mr={2} />}
                                <Text>{message.text}</Text>
                            </Box>
                        </Flex>
                    ))}
                    {isTyping && (
                        <Flex justify="flex-start" mb={2}>
                            <Box maxW="80%" px={3} py={1} borderRadius="lg" bg="gray.200" color="black">
                                <Flex align="center">
                                    {/* <Icon as={FaRobot} mr={2} /> */}
                                    <FaRobot mr={2} />
                                    <Text>Friend is typing...</Text>
                                </Flex>
                            </Box>
                        </Flex>
                    )}
                    <div ref={messagesEndRef} />
                </VStack>
            </Box>
            <Flex p={4} borderTop="1px solid" borderColor="gray.200">
                <Input
                    placeholder="Type your message..."
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    size="lg"
                    borderRadius="full"
                    flex="1"
                    mr={2}
                />
                <Select placeholder="Languages" width="130px" mr={2} onChange={(e) => SetLanguages(e.target.value)}>
                    <option value="All Languages">All Languages</option>
                    <optgroup label="Indian">
                        <option value="English">English</option>
                        <option value="Hindi">Hindi</option>
                        <option value="Bengali">Bengali</option>
                        <option value="Telugu">Telugu</option>
                        <option value="Marathi">Marathi</option>
                        <option value="Tamil">Tamil</option>
                        <option value="Urdu">Urdu</option>
                        <option value="Gujarati">Gujarati</option>
                        <option value="Kannada">Kannada</option>
                        <option value="Odia">Odia</option>
                        <option value="Malayalam">Malayalam</option>
                        <option value="Punjabi">Punjabi</option>
                        <option value="Assamese">Assamese</option>
                        <option value="Maithili">Maithili</option>
                        <option value="Sindhi">Sindhi</option>
                        <option value="Nepali">Nepali</option>
                        {/* <!-- Add more Indian languages here --> */}
                    </optgroup>
                    <optgroup label="Other Languages">
                        <option value="Spanish">Spanish</option>
                        <option value="English">English</option>
                        <option value="French">French</option>
                        <option value="German">German</option>
                        <option value="Chinese">Chinese</option>
                        <option value="Japanese">Japanese</option>
                        <option value="Korean">Korean</option>
                        <option value="Arabic">Arabic</option>
                        <option value="Russian">Russian</option>
                        <option value="Portuguese">Portuguese</option>
                        <option value="Italian">Italian</option>
                        <option value="Dutch">Dutch</option>
                        <option value="Swedish">Swedish</option>
                        <option value="Norwegian">Norwegian</option>
                        <option value="Danish">Danish</option>
                        <option value="Greek">Greek</option>
                        <option value="Turkish">Turkish</option>
                        <option value="Thai">Thai</option>
                        <option value="Vietnamese">Vietnamese</option>
                        <option value="Indonesian">Indonesian</option>
                        {/* <!-- Add more languages from around the world here --> */}
                    </optgroup>
                </Select>


                <Button colorScheme="teal" onClick={handleSendMessage}>
                    Send
                </Button>
            </Flex>
        </Flex>
    </>
);
}

export default Friend;
